import { IEntityState } from '@signature-it/ngx-entity/store/interfaces';
import {FavoritesDTO} from "@signature-it/ngx-entity/models";

export class EntityStateModel implements IEntityState {
    previews: any;
    loadingPreviews: boolean;
    favoritesList: FavoritesDTO[];
    favoritesVars: string[];
    loadingFavoritesList: boolean;
    updatedFavoritesSuccess: boolean;
    removeFavoritesSuccess: boolean;
    processingAddToFavorites: boolean;

    constructor(attributes?: object) {
        attributes = attributes || {};

        this.previews = attributes['previews'];
        this.loadingPreviews = attributes['loadingPreviews'];
        this.favoritesList = attributes['favoritesList'];
        this.favoritesVars = attributes['favoritesVars'];
        this.loadingFavoritesList = attributes['loadingFavoritesList'] || true;
        this.updatedFavoritesSuccess = attributes['updatedFavoritesSuccess'] || false;
        this.removeFavoritesSuccess =  attributes['removeFavoritesSuccess'] || false;
        this.processingAddToFavorites =  attributes['processingAddToFavorites'] || false;
    }

}
